import React from "react";
import ClaimOptionsWidget from "./ClaimOptionsWidget";

const DocumentsWidget = ({ payload, actions }) => {
  return (
    <div className="p-2 border border-gray-300 rounded-lg bg-white">
      <h6 className="font-semibold text-customBlue mb-2">{payload.title}</h6>
      {payload.categories ? (
        payload.categories.map((category, index) => (
          <div key={index} className="mb-3">
            <h6 className="font-semibold text-gray-700">{category.title}</h6>
            <ul className="list-inside list-none text-sm pl-2">
              {category.documents.map((doc, docIndex) => (
                <li key={docIndex} className="mb-1">
                  ✅ {doc}
                </li>
              ))}
            </ul>
          </div>
        ))
      ) : (
        <ul className="list-inside list-none text-sm pl-1">
          {payload.documents.map((doc, index) => (
            <li key={index} className="mb-1">
              ✅ {doc}
            </li>
          ))}
        </ul>
      )}

      <p className="text-sm font-semibold text-customBlue mt-3 mb-1">
        For claim-related queries, you can reach us through:
      </p>

      <ClaimOptionsWidget actions={actions} />
    </div>
  );
};

export default DocumentsWidget;
